/** If a tracker's animation loop pauses longer than this (ms) — tab backgrounded,
 * device sleep, debugger, long GC — rAF stalls while the clock and feed keep
 * advancing. On the first frame back we snap entities to their current target
 * instead of gliding/crawling from a stale frozen position. Comfortably above any
 * real frame hitch (<500ms) and below the shortest feed poll (subway ~15s). */
export const STALL_RESUME_MS = 1500;
